export class ResourceType {
  constructor() {
    this.name = '';
    this.dtRange = [new Date(), new Date(2099, 1, 1, 23, 59)];
  }

  id: number;
  name: string;
  classId: number;
  className: string;
  dtRange: Array<Date | null>;
  lastupdate: Date;

  get dtRangeStart(): Date | null {
    if ((this.dtRange) && (this.dtRange.length >= 1) && this.dtRange[0] !== null) {
      return new Date(this.dtRange[0]);
    } else {
      return null;
    }
  }

  set dtRangeStart(value: Date | null) {
    this.dtRange[0] = value;
  }

  get dtRangeFinish(): Date | null {
    if ((this.dtRange) && (this.dtRange.length === 2) && this.dtRange[1] !== null) {
      return new Date(this.dtRange[1]);
    } else {
      return null;
    }
  }

  set dtRangeFinish(value: Date | null) {
    this.dtRange[1] = value;
  }
}

export class Operation {
  constructor() {
    this.name = '';
    this.versions = [new OperationVersion()];
    this.dtRange = [new Date(), new Date(2099, 1, 1, 23, 59)];
  }
  id: number;
  name: string;
  versions: Array<OperationVersion>;
  dtRange: Array<Date | null>;
  lastupdate: Date;

  get dtRangeStart(): Date | null {
    if ((this.dtRange) && (this.dtRange.length >= 1) && this.dtRange[0] !== null) {
      return new Date(this.dtRange[0]);
    } else {
      return null;
    }
  }

  set dtRangeStart(value: Date | null) {
    this.dtRange[0] = value;
  }

  get dtRangeFinish(): Date | null {
    if ((this.dtRange) && (this.dtRange.length === 2) && this.dtRange[1] !== null) {
      return new Date(this.dtRange[1]);
    } else {
      return null;
    }
  }

  set dtRangeFinish(value: Date | null) {
    this.dtRange[1] = value;
  }
}

export class OperationVersion {
  constructor() {
    this.id = 0;
    this.duration = null;
    this.description = '';
    this.resources = [new OperationResource()];
  }
  id: number;
  duration: number | null;
  description: string;
  resources: Array<OperationResource>;
}

export class OperationResource {
  constructor() {
    this.duration = null;
    this.amount = null;
  }
  typeId: number;
  typeName: string;
  duration: number | null;
  amount: number | null;
}

export class Modification {
  constructor() {
    this.modifiers = [new ModificationModifiers()];
    this.dtRange = [new Date(), new Date(2099, 1, 1, 23, 59)];
    this.name = '';
  }

  id: number;
  name: string;
  modifiers: Array<ModificationModifiers>;
  dtRange: Array<Date | null>;
  lastupdate: Date;

  get dtRangeStart(): Date | null {
    if ((this.dtRange) && (this.dtRange.length >= 1) && this.dtRange[0] !== null) {
      return new Date(this.dtRange[0]);
    } else {
      return null;
    }
  }

  set dtRangeStart(value: Date | null) {
    this.dtRange[0] = value;
  }

  get dtRangeFinish(): Date | null {
    if ((this.dtRange) && (this.dtRange.length === 2) && this.dtRange[1] !== null) {
      return new Date(this.dtRange[1]);
    } else {
      return null;
    }
  }

  set dtRangeFinish(value: Date | null) {
    this.dtRange[1] = value;
  }
}

export class ModificationModifiers {
  constructor() {
    this.id = null;
    this.value = null;
    this.name = [null, null];
  }
  id: number | null;
  name: Array<string | null>;
  value: number | null;

  get nameEnglish(): string | null {
    if ((this.name) && (this.name.length >= 1)) {
      return this.name[0];
    } else {
      return null;
    }
  }
  get nameLocal(): string | null {
    if ((this.name) && (this.name.length === 2)) {
      return this.name[1];
    } else {
      return null;
    }
  }
}

export class Reference {
  id: number;
  name: Array<string | null>;

  get nameEnglish(): string | null {
    if ((this.name) && (this.name.length >= 1)) {
      return this.name[0];
    } else {
      return null;
    }
  }
  get nameLocal(): string | null {
    if ((this.name) && (this.name.length === 2)) {
      return this.name[1];
    } else {
      return null;
    }
  }
}

export class ServiceSchedule {
  constructor() {
    this.modification = new Modification();
    this.description = '';
    this.processes = [new ServiceSchedulesProcesses()];
    this.dtRange = [new Date(), new Date(2099, 1, 1, 23, 59)];
  }
  id: number;
  modification: Modification;
  description: string;
  serviceScheduleTypeId: number;
  serviceScheduleTypeName: string;
  time: number;
  processes: Array<ServiceSchedulesProcesses>;
  dtRange: Array<Date | null>;

  get dtRangeStart(): Date | null {
    if ((this.dtRange) && (this.dtRange.length >= 1) && this.dtRange[0] !== null) {
      return new Date(this.dtRange[0]);
    } else {
      return null;
    }
  }

  set dtRangeStart(value: Date | null) {
    this.dtRange[0] = value;
  }

  get dtRangeFinish(): Date | null {
    if ((this.dtRange) && (this.dtRange.length === 2) && this.dtRange[1] !== null) {
      return new Date(this.dtRange[1]);
    } else {
      return null;
    }
  }

  set dtRangeFinish(value: Date | null) {
    this.dtRange[1] = value;
  }
}

export class ServiceSchedulesProcesses {
  constructor() {
    this.id = null;
    this.name = '';
    this.start = null;
    this.finish = null;
    // this.operation = new OperationVersion();
  }
  id: number | null;
  name: string;
  start: number | null;
  finish: number | null;
  // operation: OperationVersion;

  get nameEnglish(): string | null {
    if ((this.name) && (this.name.length >= 1)) {
      return this.name[0];
    } else {
      return null;
    }
  }
  get nameLocal(): string | null {
    if ((this.name) && (this.name.length === 2)) {
      return this.name[1];
    } else {
      return null;
    }
  }
}

export class AllReference {
  constructor() {
    this.aircraft_types = [];
    this.aircraft_kinds = [];
    this.aircraft_types = [];
    this.airlines = [];
    this.airports = [];
    this.countries = [];
    this.geo_types = [];
    this.ladder_types = [];
    this.movement_types = [];
    this.regularities = [];
    this.stand_types = [];
    this.resource_classes = []
  }
  aircraft_classes: Array<Reference>;
  aircraft_kinds: Array<Reference>;
  aircraft_types: Array<Reference>;
  airlines: Array<Reference>;
  airports: Array<Reference>;
  countries: Array<Reference>;
  geo_types: Array<Reference>;
  ladder_types: Array<Reference>;
  movement_types: Array<Reference>;
  regularities: Array<Reference>;
  stand_types: Array<Reference>;
  resource_classes: Array<Reference>;
}

export class Resource {
  constructor() {
    this.name = ['', ''];
    this.typeId = null;
    this.typeName = '';
    this.divisionId = null;
    this.divisionName = '';
    this.classId = null;
    this.dtRange = [new Date(), new Date(2099, 1, 1, 23, 59)];
  }

  id: number;
  name: Array<string | null>;
  typeId: number | null;
  typeName: string;
  divisionId: number | null;
  divisionName: string;
  classId: number | null;
  dtRange: Array<Date | null>;
  lastupdate: Date;

  get dtRangeStart(): Date | null {
    if ((this.dtRange) && (this.dtRange.length >= 1) && this.dtRange[0] !== null) {
      return new Date(this.dtRange[0]);
    } else {
      return null;
    }
  }

  set dtRangeStart(value: Date | null) {
    this.dtRange[0] = value;
  }

  get dtRangeFinish(): Date | null {
    if ((this.dtRange) && (this.dtRange.length === 2) && this.dtRange[1] !== null) {
      return new Date(this.dtRange[1]);
    } else {
      return null;
    }
  }

  set dtRangeFinish(value: Date | null) {
    this.dtRange[1] = value;
  }

  get nameFirst(): string | null {
    if ((this.name) && (this.name.length >= 1)) {
      return this.name[0];
    } else {
      return null;
    }
  }

  set nameFirst(value: string | null) {
    this.name[0] = value;
  }

  get nameSecond(): string | null {
    if ((this.name) && (this.name.length === 2)) {
      return this.name[1];
    } else {
      return null;
    }
  }

  set nameSecond(value: string | null) {
    this.name[1] = value;
  }

  get names(): string | null {
    if (this.name) {
      return this.name.join(' ');
    } else {
      return null;
    }
  }
}

export class Division {
  constructor() {
    this.name = '';
    this.parentId = null;
    this.dtRange = [new Date(), new Date(2099, 1, 1, 23, 59)];
  }

  id: number;
  name: string;
  parentId: number | null;
  dtRange: Array<Date | null>;
  lastupdate: Date;

  get dtRangeStart(): Date | null {
    if ((this.dtRange) && (this.dtRange.length >= 1) && this.dtRange[0] !== null) {
      return new Date(this.dtRange[0]);
    } else {
      return null;
    }
  }

  set dtRangeStart(value: Date | null) {
    this.dtRange[0] = value;
  }

  get dtRangeFinish(): Date | null {
    if ((this.dtRange) && (this.dtRange.length === 2) && this.dtRange[1] !== null) {
      return new Date(this.dtRange[1]);
    } else {
      return null;
    }
  }

  set dtRangeFinish(value: Date | null) {
    this.dtRange[1] = value;
  }
}
